
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questions/[id]/question/[...slug]",
      function () {
        return require("private-next-pages/questions/[id]/question/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questions/[id]/question/[...slug]"])
      });
    }
  